import { configureStore } from '@reduxjs/toolkit'


import { onboardFormSlice } from './onboardFormState'


export const store = configureStore({
    reducer: {
        onboardForm: onboardFormSlice.reducer,
    }
})